import { atom } from 'jotai';

export type BulkDealDocsAction = 'upload' | 'view' | null;

export const selectedBulkDealDocsActionState = atom<BulkDealDocsAction>(null);
export const selectedBulkUploadIdState = atom<number | null>(null);
